import { ChatMessageType } from "@/api/chat";
import { createContext, useContext } from "react";

type ChatMessagesContextType = {
  canSendMessages: boolean;
  sendMessage: (message: string, useAI: boolean) => void;
  messages: ChatMessageType[];
  submitEvent: (event: string | object) => void;
  usersTyping: { first_name: string; last_name: string; id: string }[];
};

export const useChatMessagesContext = () => useContext(ChatMessagesContext);
export const ChatMessagesContext = createContext<ChatMessagesContextType>({
  canSendMessages: false,
  sendMessage: (message: string, useAI: boolean) => {
    console.warn("sendMessage not implemented", message, useAI);
  },
  messages: [],
  submitEvent: (event: string | object) => {
    console.warn("submitEvent not implemented", event);
  },
  usersTyping: [],
});
